export default __webpack_public_path__ + "static/media/kitchen3-afterB-768w.e21cdb30.avif";